import { render } from "./TransactionalHeader.vue?vue&type=template&id=4f13c7da"
import script from "./TransactionalHeader.vue?vue&type=script&lang=js"
export * from "./TransactionalHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__